<template>
  <div v-if="product.bundleOptions">
    <div v-for="(bundleItem, key) in bundleItems" :key="key">
      <bundle-item-list-item
        v-show="
          bundleItem.hasMoreThanOneColour || bundleItem.hasMoreThanOneSize
        "
        :bundle-item="bundleItem"
        :stock="product.bundleOptions[bundleItem.id]"
        :index="key"
        @input="setBundleItemOptions($event, key)"
      />
    </div>
    <div v-if="bundleItemsWithOneSizeAndColour.length">
      <p>
        + {{ bundleItemsWithOneSizeAndColour.length }} other bundle item{{
          bundleItemsWithOneSizeAndColour.length > 1 ? 's' : ''
        }}
      </p>
      <tml-grid :breakpoints="{xs: 5}" :spacing="{xs: 0}">
        <div
          v-for="(bundleItem, key) in bundleItemsWithOneSizeAndColour"
          :key="key"
        >
          <tml-image
            :alt="`${bundleItem.name} image`"
            :src="bundleItem.image?.size(120)"
          />
        </div>
      </tml-grid>
    </div>
  </div>
</template>

<script>
import {BundleItem} from '../classes/bundleItem';

import BundleItemListItem from './BundleItemListItem.vue';

export default {
  name: 'BundleItemList',

  components: {
    BundleItemListItem,
  },

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      bundleItems: [],

      activeOptions: [],
    };
  },

  computed: {
    bundleItemsWithOneSizeAndColour() {
      return this.bundleItems.filter(
        item => !item.hasMoreThanOneColour && !item.hasMoreThanOneSize
      );
    },
  },

  mounted() {
    this.convertBundleItems();

    this.emitBundleItems();
  },

  methods: {
    convertBundleItems() {
      const bundleItems = [];
      this.product.bundleItems.forEach(bundleItem => {
        bundleItems.push(new BundleItem(bundleItem));
      });
      this.bundleItems = bundleItems;
    },

    setBundleItemOptions(value, key) {
      this.activeOptions[key] = value;

      this.emitBundleItems();
    },

    emitBundleItems() {
      this.$emit('input', this.activeOptions);
    },
  },
};
</script>
